export function loadScript(src: string, attrs: Record<string, string | boolean> = {}): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    Object.entries(attrs).forEach(([k, v]) => {
      if (typeof v === 'boolean') {
        if (v) (s as any)[k] = true;
      } else {
        s.setAttribute(k, v);
      }
    });
    s.onload = () => resolve();
    s.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(s);
  });
}
